import { View } from "react-native";
import {
  Dialog,
  DialogActions,
  DialogBodyText,
  DialogHeader,
  DialogIcon,
  DialogPrimaryButton,
  DialogSecondaryButton,
} from "@louise/moon-ui";
import StatusBadge from "./StatusBadge";

const DONOR_REGISTRY_DIALOG_ILLUSTRATION =
  require("@src/apps/moon/assets/images/donor-registry-dialog-illustration.png") as number;

type ComingSoonSheetProps = {
  open: boolean;
  onClose: () => void;
  title: string;
  description: string;
  onNotify?: () => void;
};

export function ComingSoonSheet({
  open,
  onClose,
  title,
  description,
  onNotify,
}: ComingSoonSheetProps) {
  return (
    <Dialog visible={open} onClose={onClose} closeButton="minimal">
      <DialogIcon
        source={DONOR_REGISTRY_DIALOG_ILLUSTRATION}
        width={84}
        height={96}
        style={{ marginBottom: 14 }}
        testID="donor-registry-dialog-illustration"
      />
      <DialogHeader
        title={title}
        style={{ alignItems: "center", width: "100%", marginBottom: 10 }}
        titleStyle={{ textAlign: "center", width: "100%" }}
      />
      <View style={{ alignItems: "center", marginBottom: 16 }}>
        <StatusBadge type="coming-soon" />
      </View>
      <DialogBodyText style={{ textAlign: "center", marginTop: 0 }}>
        {description}
      </DialogBodyText>
      <DialogActions style={{ marginTop: 24 }}>
        {onNotify ? (
          <DialogPrimaryButton
            label="Notify me when ready"
            onPress={() => {
              onNotify();
              onClose();
            }}
          />
        ) : (
          <DialogSecondaryButton label="Got it" onPress={onClose} />
        )}
      </DialogActions>
    </Dialog>
  );
}
